module.exports = __webpack_public_path__ + "static/thau-729f44570c8d222f3cfda995d4ed8df5.png";